import React from 'react';
import { useIntl } from 'react-intl/dist';
import styled from 'styled-components';

const StyledSection = styled.div`
    div {
        width: 100% !important;
        @media (max-width: 768px) {
            padding-top: 1rem;
        }
    }
`;

const StyledDetails = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: start;
    gap: 0.7rem;
`;

const StyledSubTitle = styled.h4`
    border-bottom: 1px solid #e3e3e3;
    margin-bottom: 2rem;
    padding-bottom: 0.2em;
    font-weight: 300;
    text-transform: uppercase;
`;

const InfoSection: React.FC<{ title?: string; children: React.ReactNode }> = ({ title, children }) => {
    const intl = useIntl();

    return (
        <StyledSection>
            {title && <StyledSubTitle className="table-caption">{intl.formatMessage({ id: title })}</StyledSubTitle>}
            <StyledDetails>{children}</StyledDetails>
        </StyledSection>
    );
};

export default InfoSection;
